/* Shared cart submission: preserve Shopify prices and surface recoverable errors. */
(() => {
  const pending = new WeakSet();
  // No quantity cap: pack discounts are capped at 3 units in Shopify (scripts/omnibus.py), not the cart.
  window.NutriCart = {
    async add(payload, button) {
      if (button && (button.disabled || pending.has(button))) return false;
      const original = button?.innerHTML;
      if (button) {
        pending.add(button);
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.innerHTML = 'DODAWANIE…';
        if (!button.cartError) {
          button.cartError = document.createElement('p');
          button.cartError.className = 'cart-action-error';
          button.cartError.setAttribute('role', 'alert');
          (button.closest('.product-form, .product-card, .bestseller-card, .upsell-pack-card') || button).insertAdjacentElement('afterend', button.cartError);
        }
        button.cartError.textContent = '';
      }
      try {
        const isForm = payload instanceof FormData;
        // Ask for the rendered drawer in the same request, so it opens already showing the new product.
        if (isForm) payload.set('sections', 'cart-drawer'); else payload = {...payload, sections: 'cart-drawer'};
        const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
          method: 'POST',
          headers: isForm ? {Accept: 'application/json'} : {Accept: 'application/json', 'Content-Type': 'application/json'},
          body: isForm ? payload : JSON.stringify(payload)
        });
        const data = await response.json();
        if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : 'Nie udało się dodać produktu. Spróbuj ponownie.');
        const drawer = document.querySelector('cart-drawer');
        if (drawer?.open) {
          drawer.open(data.sections?.['cart-drawer']);
        } else document.dispatchEvent(new Event('cart:open'));
        return true;
      } catch (error) {
        if (button?.cartError) button.cartError.textContent = error.message === 'Failed to fetch' ? 'Sprawdź połączenie i spróbuj ponownie.' : error.message;
        return false;
      } finally {
        if (button) {
          pending.delete(button);
          button.disabled = false;
          button.removeAttribute('aria-busy');
          button.innerHTML = original;
        }
      }
    }
  };
})();
